import { Component, OnInit, Sanitizer } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { USERTYPE } from 'src/app/core/enums/routing-item.enum';
import { WarningBannerDialogComponent } from 'src/app/shared/components/warning-banner-dialog/warning-banner-dialog.component';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { Spinner } from '../../../../../core/services/spinner.service';
import { SRMModel } from '../../../../../shared/model/srm.model';
import { SrmService } from '../../../../../shared/service/srm.service';
import { RSP_ROLES } from './../../../../../shared/enums/admin-enum';
import { NewsService } from './../../../../../shared/service/news.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  public welcome: SRMModel = new SRMModel();
  public name = 'Name';
  public jobTitle = 'Job Title';
  public title = 'Title';
  public message: any = 'Message';
  public avatarUrl = '/assets/images/icons/avatar1.png';
  public imageUrl = '/assets/images/supplier-portal-cover.png';
  public loading = true;
  public chartTitle = 'Based on GE assessment of performance';
  public type = '';

  chartName = [
    {
      name: 'sustainability',
      v: 0,
      type: 'Sustainability',
      unit: '',
      n: 0,
      m: 0,
      startLetter: 'S',
      className: (() => 'class1'),
      color: 'white', // color default is null,
      b: 0,
      e: 0
    },
    {
      name: 'tqs',
      v: 0,
      type: 'Quality',
      unit: '%',
      n: 0,
      m: 0,
      startLetter: 'Q',
      className: (() => 'class2'),
      color: 'white',
      b: 0,
      e: 0
    },
    {
      name: 'otdpd',
      v: 0,
      type: 'Delivery',
      unit: '%',
      n: 0,
      m: 0,
      startLetter: 'D',
      className: (() => 'class3'),
      color: 'white',
      b: 0,
      e: 0
    },
    {
      name: 'yoycosp',
      v: 0,
      type: 'Cost',
      unit: '%',
      n: 0,
      m: 0,
      startLetter: 'C',
      className: (() => 'class4'),
      color: 'white',
      b: 0,
      e: 0
    },
  ];

  news = [];

  constructor(
    private srmService: SrmService,
    private spinner: Spinner,
    private newsService: NewsService,
    private router: Router,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) {
    if (atob(sessionStorage.getItem(btoa('showBanner'))) === 'true' ) {
      const dialogRef = this.dialog.open(WarningBannerDialogComponent, {
        width: '500px',
        maxHeight: '600px',
        disableClose: true
      });
    }
    this.type = atob(localStorage.getItem(btoa('role'))).split(',').some(r => r === RSP_ROLES.SUPPLIER)
    ? USERTYPE.SUPPLIER_USER : USERTYPE.INTERNAL_USER;
   }

  ngOnInit() {
    this.getWellcomeMessage();
    this.getListNews();
    if (this.type === USERTYPE.SUPPLIER_USER) {
      this.getChartInfo();
    }
  }

  getWellcomeMessage() {
    this.spinner.show();
    this.srmService.getLandingPage().subscribe((res: any) => {
      this.spinner.hide();
      if (res.data) {
        this.welcome = res.data;
        this.message = this.sanitizer.bypassSecurityTrustHtml(res.data.welcomeMessage.message);
        if (!this.welcome.welcomeMessage.avatar) {
          this.welcome.welcomeMessage.avatar.resourceUrl = this.avatarUrl;
          this.welcome.welcomeMessage.image.resourceUrl = this.imageUrl;
        }
      }
    });
  }

  public onLoad() {
    this.loading = false;
  }

  public getListNews() {
    this.spinner.show();
    this.newsService.getListNews(0, 1).subscribe((res: any) => {
      this.spinner.hide();
      if (res.data.content) {
        this.news = res.data.content.map(item => {
          item.lastUpdated = new Date(item.lastUpdated).toLocaleDateString();
          return item;
        });
      }
    });
  }

  public goToNews(id?) {
    if (id) {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_NEWS, id]);
      return;
    }
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_NEWS]);
  }

  public gotoScorecard() {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_SCORECARD]);
  }

  private getChartInfo() {
    this.spinner.show();
    this.srmService.getDataGaugeChart().subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        this.chartName = this.chartName.map(chart => {
          chart.v = Number.isInteger(res.data[chart.name].v) ? res.data[chart.name].v : res.data[chart.name].v.toFixed(2);
          chart.n = res.data[chart.name].n;
          chart.m = res.data[chart.name].m;
          chart.b = res.data[chart.name].b;
          chart.e = res.data[chart.name].e;
          chart.color = res.data[chart.name].clr;
          return chart;
        });
      }
    });
  }

  /**
   *  goToScoreCard
   */
  public goToScoreCard() {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_SCORECARD]);
  }

  public getFirstCharacter = (value: string) => {
    return value.charAt(0);
  }

  public getValueWithoutFirstChar = (value: string) => {
    return value.substring(1);
  }
}
